app.controller(
    'BioListController', ['$scope', '$rootScope', '$http', '$stateParams', '$timeout', 'toastr', '$document', 'Configuration', 'BioService', '$sce', '$translate', 'SideBarService', '$window', 'AdminService', 'HelperService', BioListController]
);

function BioListController($scope, $rootScope, $http, $stateParams, $timeout, toastr, $document, Configuration, BioService, $sce, $translate, SideBarService, $window, AdminService, HelperService) {
    var vm = this;
    vm.isAllSelected = false;
    $scope.$parent.type = 'bio';
    $translate.use($rootScope.LangForInterface);
    if ($stateParams.z) {
        vm.ParamZoneId = $stateParams.z;
    }
    else {
        vm.ParamZoneId = $rootScope.DefaultGlobalZoneId;
    }

    if ($stateParams.qc) {
        vm.ParamQcId = $stateParams.qc;
    }
    else {
        vm.ParamQcId = 13600;           //Invité
    }


    $rootScope.UpdateRoles();

    vm.BioList = []; //declare an empty array
    vm.pageno = 1; // initialize page no to 1
    vm.total_count = 0;
    vm.sortKey = "FirstName";
    vm.direction = "ascending";
    vm.reverse = false,
    vm.itemsPerPage = 10; //this could be a dynamic value from a drop down
    vm.SearchVM = {};
    $rootScope.TopBarAction = {};
    $rootScope.TopBarAction.isActive = false;
    $rootScope.BatchReplaceTextResult = null;


    vm.getsearchurlparam = function (zoneId, pageno, sortKey, reverse, isTopBarActive, searchText, SearchVM) { // This would fetch the data on page change.
        if (SearchVM.Reset) {
            vm.SearchParam = "";
        }
        else {
            vm.SearchParam = HelperService.GetSearchUrlParam(SearchVM);
        }
        SearchVM.Reset = false;
        $window.location.href = $rootScope.interfaceSubFolder +'/#!/list/guest?z=' + zoneId + '&pageno=' + pageno + '&sortkey=' + sortKey + '&reverse=' + reverse + '&istopbaractive=' + isTopBarActive + '&searchText=' + searchText + vm.SearchParam;
    };


    vm.getDataV2 = function () { // This would fetch the data on page change.
        //In practice this should be in a factory.
        vm.GuestList = [];

        if ($stateParams.z != null)
            vm.ParamZoneId = $stateParams.z;

        if ($stateParams.pageno != null)
            vm.pageno = $stateParams.pageno;

        if ($stateParams.reverse != null)
            vm.reverse = $stateParams.reverse;

        if ($stateParams.sortkey != null)
            vm.sortKey = $stateParams.sortkey;

        if ($stateParams.istopbaractive != null)
            $rootScope.TopBarAction.isActive = $stateParams.istopbaractive;

        if ($stateParams.searchText != null)
            $rootScope.TopBarAction.SearchText = $stateParams.searchText;
        else
            $rootScope.TopBarAction.SearchText = "";

        if ($stateParams.mcd != null) {
            vm.ParamMcd = $stateParams.mcd;
        }

        if ($rootScope.TopBarAction.isActive == 'true')
            $scope.showDetail('rechercher');
        else
            $scope.closeDetail('rechercher');
        //Get List 
        //var promiseBioList = BioService.GetBioList(zoneId, vm.itemsPerPage, pageno, sortKey, reverse, $rootScope.LangForWork, isTopBarActive, searchText, SearchVM);
        var promiseBioList = BioService.GetBioList(vm.ParamZoneId, vm.ParamQcId, vm.itemsPerPage, vm.pageno, vm.sortKey, vm.reverse, $rootScope.LangForWork, $rootScope.TopBarAction.isActive, $stateParams.search, $stateParams.gsearch, $stateParams.searchText, vm.SearchVM);

        promiseBioList.then(function (response) {
            vm.BioList = response.data.BioList;  // data to be displayed on current page.
            $rootScope.InitListSelectedId(vm.BioList, 'bio', vm);
            vm.total_count = response.data.total_count; // total data count.
            $rootScope.total_count = response.data.total_count;
            vm.SearchVM = response.data.SearchVM;
            $rootScope.SideBarSearchVM = vm.SearchVM
            //$scope.ChangeZoneById(vm.ParamZoneId);
            $rootScope.TopBarAction.StatusList = $rootScope.StatusList4WorkflowObject;
            $rootScope.TopBarAction.ClientList = angular.copy(vm.SearchVM.Client);
        });
    };

    // vm.getData(vm.ParamZoneId, vm.pageno, vm.sortKey, vm.reverse, $rootScope.TopBarAction.isActive, $rootScope.TopBarAction.SearchText, vm.SearchVM); // Call the function to fetch initial data on page load.

    vm.getData = function (zoneId, pageno, sortKey, reverse, isTopBarActive, searchText, SearchVM) { // This would fetch the data on page change.
        $window.location.href = $rootScope.interfaceSubFolder + '/#!/list/guest?z=' + zoneId + '&pageno=' + pageno + '&sortkey=' + sortKey + '&reverse=' + reverse + '&istopbaractive=' + isTopBarActive + '&searchText=' + searchText + '&search=' + $stateParams.search + '&gsearch=' + $stateParams.gsearch;
    };
    vm.getDataV2();

    $scope.$parent.search = $stateParams.search;
    $scope.$parent.gsearch = $stateParams.gsearch;
    $scope.$parent.qc = vm.ParamQcId;
    $scope.$parent.sortkey = vm.sortKey;
    $scope.$parent.reversesort = vm.reverse;


    // $scope.vm = vm;
    $scope.sort = function (keyname) {
        vm.sortKey = keyname;   //set the sortKey to the param passed
        vm.reverse = !vm.reverse; //if true make it false and vice versa
        vm.getData(vm.ParamZoneId, vm.pageno, keyname, vm.reverse, $rootScope.TopBarAction.isActive, $rootScope.TopBarAction.SearchText, vm.SearchVM);
    }

    vm.getUserUrl = function (id, lang, index, sortKey, reverse, filter, itemZoneId) {
        var urlDynamique = '/#!/consultation/bio?id=';
        if ($rootScope.globals.currentUser.RoleId == $rootScope.EnumRole.Author) {
            urlDynamique = "/#!/consultation/bio?id=";
        }
        if ($rootScope.globals.currentUser.RoleId == $rootScope.EnumRole.Corrector) {
            urlDynamique = "/#!/correction/bio?id=";
        }
        if ($rootScope.globals.currentUser.RoleId == $rootScope.EnumRole.Translator) {
            urlDynamique = "/#!/traduction/bio?lang2=" + $rootScope.LangForTranslationDestination + "&id=";
        }
        return $rootScope.interfaceSubFolder + urlDynamique + id + "&lang=" + lang + "&index=" + index + "&sortKey=" + sortKey + "&reverse=" + reverse + "&z=" + itemZoneId;
    }


    $rootScope.AdvancedSearch = function AdvancedSearch() {
        $rootScope.resetSelectedListId();
        $rootScope.TopBarAction.isActive = false;
        vm.getsearchurlparam(vm.ParamZoneId, vm.pageno, vm.sortKey, vm.reverse, $rootScope.TopBarAction.isActive, $rootScope.TopBarAction.SearchText, $rootScope.SideBarSearchVM);

    };

    $rootScope.GlobalAdvancedSearch = function GlobalAdvancedSearch(key, value) {
        if (value != null) {
            $rootScope.SideBarSearchVM.GlobalSearch.SearchValues[key] = value;
            $rootScope.SideBarSearchVM.GlobalSearch.Keyword = "";
            $rootScope.AdvancedSearch();
        }
    };

    $rootScope.removeTags = function (key) {
        delete $rootScope.SideBarSearchVM.GlobalSearch.SearchValues[key];
        $rootScope.AdvancedSearch();
        //$rootScope.$apply();
    };
    $rootScope.ShowResultBeforeReplace = function () {
        $rootScope.TopBarAction.isActive = true;
        vm.getData(vm.ParamZoneId, vm.pageno, vm.sortKey, vm.reverse, $rootScope.TopBarAction.isActive, $rootScope.TopBarAction.SearchText, $rootScope.SideBarSearchVM);

    }

    $rootScope.BatchReplaceText = function () {
        $rootScope.TopBarAction.IdList = GetSelectedIdList(vm.BioList, 'Id');
        $rootScope.TopBarAction.Lang = $rootScope.LangForWork;
        if ($rootScope.TopBarAction.IdList.length > 0 && $rootScope.TopBarAction.SearchText != undefined && $rootScope.TopBarAction.ToReplaceText != undefined) {
            SideBarService.BatchReplaceText($rootScope.TopBarAction)
            .then(
                    function success(data) {
                    },
                    function error(data) { });
        }
    }

    $rootScope.BatchModifyClient = function () {
        $rootScope.TopBarAction.IdList = GetSelectedIdList(vm.BioList, 'Id');
        $rootScope.TopBarAction.ObjectType = $rootScope.EnumLinkType.Bio;
        $rootScope.TopBarAction.Lang = $rootScope.LangForWork;

        SideBarService.BatchModifyClient($rootScope.TopBarAction)
        .then(
                function success(data) {
                    window.location.reload();
                },
                function error(data) { });
    }

    $rootScope.BatchModifyStatus = function () {
        $rootScope.TopBarAction.IdList = GetSelectedIdList(vm.BioList, 'Id');
        $rootScope.TopBarAction.ObjectType = $rootScope.EnumLinkType.Bio;
        $rootScope.TopBarAction.Lang = $rootScope.LangForWork;

        SideBarService.BatchModifyStatus($rootScope.TopBarAction)
        .then(
                function success(data) {
                    window.location.reload();
                },
                function error(data) { });
    }
};